import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Params } from '@angular/router';

import { AbstractService } from '@core/http/abstract.service';

import { ApiResponse, AuthMethod, RestrictionType } from './users.entity';

@Injectable({
  providedIn: 'root'
})
export class AuthService extends AbstractService {
  getStatus(): Observable<ApiResponse.GetStatus> {
    return this.get<ApiResponse.GetStatus>('/users/auth/status');
  }

  getAuthLink(
    method: AuthMethod,
    link: boolean = false,
    register: boolean = false,
    route: string | null = null
  ): Observable<ApiResponse.RedirectUrl> {
    return this.get<ApiResponse.RedirectUrl>(
      `/users/auth/${method}/redirect-url`,
      { link, register, route },
      { throwError: true }
    );
  }

  authenticate<T>(
    method: AuthMethod,
    data: T,
    isRegistering = false
  ): Observable<ApiResponse.SuccessAuthentication> {
    return this.post<ApiResponse.SuccessAuthentication>(
      `/users/auth/${method}/authenticate${isRegistering ? '?register=1' : ''}`,
      data,
      { throwError: true }
    );
  }

  linkAccount<T>(method: AuthMethod, data: T): Observable<void> {
    return this.post<void>(`/users/auth/${method}/link`, data);
  }

  claimTelegramBonus(): Observable<void> {
    return this.post<void>(
      '/users/telegram/claim-bonus',
      {},
      { throwError: true }
    );
  }

  claimVkBonus(): Observable<void> {
    return this.post<void>('/users/vk/claim-bonus', {}, { throwError: true });
  }

  cancelWager(): Observable<void> {
    return this.post<void>('/users/cancel-wager', {}, { throwError: true });
  }

  createRestriction(
    userId: number,
    autoremoveAt: number | null,
    type: RestrictionType,
    context: any
  ): Observable<void> {
    return this.post<void>(
      `/users/${userId}/restrictions`,
      {
        autoremoveAt,
        type,
        context
      },
      { throwError: true }
    );
  }

  acceptTerms(): Observable<void> {
    return this.post<void>('/users/accept-tos');
  }

  handshake(
    payload?: string,
    iv?: string,
    refCode?: string | null,
    marketingCode?: string | null,
    utmParams?: Params | null
  ): Observable<void> {
    return this.post<void>(
      '/sessions/handshake',
      {
        payload,
        iv,
        refCode,
        marketingCode
      },
      {},
      utmParams
    );
  }
}
